import { RowHeights } from '@core/config/row-heights';
import { Project } from '@core/models/project.model';
import { ViewByEnum } from '@portal-shared/app/enums/view-by.enum';
import { FormatUtils } from '@portal-shared/app/utils/format.utils';
import { ProjectGroupRowDto } from '@services/dtos/rows/project-group-row.dto';
import { AssignmentGroupDefinition } from '@services/models/group-definition.model';
import { PlanningBoardGroupRowType } from '@shared/components/grids/rows/groups/planning-board-group-row-type.enum';
import { SortModelItem } from 'ag-grid-community';
import { PlanningGroupRow } from './planning-group.row';

export class ProjectGroupRow extends PlanningGroupRow {
  public override type = PlanningBoardGroupRowType.Project;
  public override height = RowHeights.planningGrid.rowMedium;
  public override isRowDroppable = false;
  public project: Project;
  public override styleClasses = [`p-${this.dto.projectCode}`];

  public expandAll: boolean = false;

  public constructor(
    public dto: ProjectGroupRowDto,
    public override projectId: string = dto.projectId
  ) {
    super(dto, projectId);
    this.project = new Project(
      dto.projectId,
      dto.projectCode,
      dto.projectIsActive,
      dto.projectDescription,
      dto.customerId,
      dto.customerCode,
      dto.customerDesc
    );
    this.label = this.project.label;
  }

  public toGroupDefinition(): AssignmentGroupDefinition {
    return {
      projectId: this.projectId
    };
  }

  public static getDefaultSortModel(): SortModelItem[] {
    const codeItem: SortModelItem = { colId: 'projectCode', sort: 'asc' };
    const descItem: SortModelItem = { colId: 'projectDescription', sort: 'asc' };

    switch (FormatUtils.viewBy) {
      case ViewByEnum.viewByCode:
        return [codeItem];
      case ViewByEnum.viewByDescription:
        return [descItem];
      case ViewByEnum.viewByCodeDescription:
        return [codeItem, descItem];
    }
  }
}
